import React from 'react';
import { st, classes } from './Footnote.st.css';
import Divider from '../../../Divider';
import { useBaseModalLayoutContext } from '../../BaseModalLayoutContext';
import { FootnoteProps } from './Footnote.types';

export const Footnote = ({
  dataHook,
  className,
  children,
  skin = 'neutral',
}: FootnoteProps) => {
  const { footnoteClassName, footnote = children } =
    useBaseModalLayoutContext();

  return (
    (footnote && (
      <div
        data-hook={dataHook}
        className={st(
          classes.root,
          {
            skin,
          },
          footnoteClassName,
          className,
        )}
      >
        <Divider />
        <div className={classes.innerContent}>{footnote}</div>
      </div>
    )) ||
    null
  );
};

Footnote.displayName = 'BaseModalLayout.Footnote';
